import React, { useRef, useEffect, useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate, useLocation } from 'react-router-dom'; 
import NavBar from '../../components/NavBar/NavBar';
import style from './About.module.css';
import img2 from './media/img/ETERVOZ ABOUT US 2.png';
import img3 from './media/img/ETERVOZ ABOUT US.png';
import LoadLogo from '../../components/LoadLogo/LoadLogo';
import Contact from '../../components/Contact/Contact';
import Clients from '../../components/Clients/Clients';
import OurServices from '../../components/OurServices/OurServices';
import Whatsapp from '../../components/Whatsapp/Whatsapp';
import BurgerButton from '../../components/BurgerButton/BurgerButton';
import video1 from '../../media/videos/Reel Cartel.mp4';
import video2 from '../../media/videos/EtervozREEl.mp4';
import imagen1 from './media/img/TWO01001.webp';
import imagen2 from './media/img/FOTO 2 CABIN.webp';
import imagen3 from './media/img/TWO01014.webp';


const About = ({ language, toggleLanguage, translations }) => {
    const [exit, setExit] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const videoRef = useRef(null);
  const videoRef2 = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // Duración de la animación en milisegundos
      easing: "ease-in-out", // Tipo de transición
      once: false, // Si debe ejecutarse solo una vez
    });
  }, []);



  useEffect(() => {
    if (videoRef2.current) {
      videoRef2.current.play();
    }
  }, []);

 



  return (
    <div className={style.aboutAllContainer}>
              <div className='page-transition'><div className='loadLogo'><LoadLogo/></div></div>
              <div className={`${exit === true ? 'transiition-exit' : ''} `}></div>
              <BurgerButton language={language} toggleLanguage={toggleLanguage} translations={translations} />
              <NavBar language={language} toggleLanguage={toggleLanguage} translations={translations} />
              <Whatsapp language={language} translations={translations}/>
        <div className={style.aboutCover} >
          <h1>{translations[language].aboutTitulo1}</h1>
          <p>{translations[language].aboutTexto1}</p>          
        </div>
        <div className={style.imagenesCover}>
            <img src={imagen1}/>
            <img src={imagen2}/>
            <img src={imagen3}/>
          </div>
        <div className={style.tipsAbout}>
          <h1>{translations[language].aboutTitulo2}</h1>
            <p data-aos="fade-up">{translations[language].aboutTexto2}</p>
        </div>

        <div className={style.videoDiv}>
        <video
        ref={videoRef}
        autoPlay
        muted
        loop
        controls={true} // Si no quieres mostrar los controles
        className={style.aboutVideo} // Ajuste de tamaño opcional
        ><source src={video2} type="video/mp4" /></video>
      <img src={img2}/>
        </div>
        
        <OurServices language={language} translations={translations}/>
        
        <div className={style.videoDiv}>
        <img src={img3}/>
        <video
        ref={videoRef2}
        autoPlay
        muted
        loop
        controls={true} // Si no quieres mostrar los controles
        className={style.aboutVideo} // Ajuste de tamaño opcional
        ><source src={video1} type="video/mp4" /></video>
        </div>
        <Clients language={language} translations={translations} />
        <Contact language={language} translations={translations} />
    </div>
  )
}

export default About
